import React from "react";
import classNames from "classnames";
import "./style.scss";

interface Props {
  className?: string;
  block?: boolean;
  values?: {
    title: string;
    id: string | number;
  }[];
  value: string | number;
  onChange(params: string | number): void;
}

export const Radio: React.FC<Props> = ({
  block = false,
  className,
  values = [],
  value,
  onChange,
}) => {
  return (
    <div className={className}>
      <div
        className={classNames(
          !block && "d-flex",
          "flex-wrap",
          "radio-container",
        )}
      >
        {values.map(({ title, id: itemVal }) => {
          return (
            <label
              key={itemVal}
              className={classNames("radio-control", {
                active: itemVal === value,
              })}
            >
              <div>{title}</div>
              <input
                type="radio"
                checked={itemVal === value}
                onChange={() => onChange(itemVal)}
              />
              <span></span>
            </label>
          );
        })}
      </div>
    </div>
  );
};
